module.exports = __webpack_public_path__ + "bd4430cfbcd0eeb61f1129860e5348e5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/student-s.png
// module id = 1711
// module chunks = 0